import request from '@/utils/request'

export const baseUrl = '/svg'

export interface SVGProperties {
  created_at: Date
  default: boolean
  fileSize: number
  id: number
  name: string
  path: string
  redirect: string
  roles: string
  slug: string
  uid: string
  defaultStacks: string
}

export class SVGProperties {
  public created_at = new Date()
  public default = false
  public fileZise = 0
  public id = 0
  public name = ''
  public path = ''
  public redirect = ''
  public roles = ''
  public slug = ''
  public uid = ''
  public defaultStacks = ''
}

export function FindSVG(): Promise<SVGProperties[]> {
  return request.get(baseUrl)
}

export function GetSVGProperties(uid: string): Promise<SVGProperties> {
  return request.get(`${baseUrl}/${uid}`)
}

export function DeleteSVG(uid: string) {
  return request.delete(`${baseUrl}/${uid}`)
}

export function PatchSVGProperties(
  uid: string,
  svg: SVGProperties
): Promise<SVGProperties> {
  return request.patch(`${baseUrl}/${uid}`, svg)
}

export function LookupSVGFile(uid: string): Promise<SVGProperties> {
  return request.get(`${baseUrl}/lookup/${uid}`)
}

export function FindNavbar(): Promise<SVGProperties[]> {
  return request.get(`${baseUrl}/navbar`)
}

export function GetThumbnail(uid: string) {
  return request.get(`${baseUrl}/thumbnail/${uid}`)
}

export function GetSVGFile(uid: string, slug: string): Promise<string> {
  return request.get(`${baseUrl}/${uid}/${slug}`)
}

export function Create(svg: SVGProperties, file: File): Promise<SVGProperties> {
  const formData = new FormData()
  formData.append('name', svg.name)
  formData.append('roles', svg.roles)
  formData.append('file', file)

  return request.post(baseUrl, formData, {
    headers: { 'content-type': 'multipart/form-data' },
  })
}

export function UploadFile(uid: string, file: File) {
  const formData = new FormData()
  formData.append('file', file)

  return request.post(`${baseUrl}/upload/${uid}`, formData, {
    headers: { 'content-type': 'multipart/form-data' },
  })
}
